import requests from './httpService';
const TicketBookingService = {
  getAllTicketBooking() {
    return requests.get(`/ticketbooking/list`);
  },
  creteTicketBooking(body, headers = {}){
    return requests.post('/ticketbooking/add', body, { headers }); 
  },
  getAllTicketBookingById(id,body){
    return requests.post(`/ticketbooking/list/${id}`,body); 
  },
  deleteTicketBooking(body){
    return requests.delete(`/ticketbooking/${body._id}`); 
    
  },
  getTicketBookingById(id) {
    return requests.get(`/ticketbooking/${id}` );
  },

  findTicketBookingList(body){
    return requests.post(`/ticketbooking/find`,body); 
  },
  upadeTicketBooking(body) {
    return requests.put(`/ticketbooking/${body._id}`,body); 
  },
  getAllProfileId(body) {
    return requests.post(`/ticketbooking/profileid`,body);
  },
  
  getAllProfileSearch(body) {
    return requests.post(`/ticketbooking/search`,body);
  },
  // router.post('/report', getTicketBookingList);
  getTicketBookingList(body){
    return requests.post(`/ticketbooking/report`,body);
  },
  paymentProcess(body){
    return requests.post(`/ticketbooking/ccav/payment`,body);
  },
  paytmPaymentProcess(body){
    return requests.post(`/ticketbooking/paytm/payment`,body);
  },
  getQRcodeByMobile(body) {
    return requests.post(`/ticketbooking/getqrcodebymobile`,body );
  },
  /**
   * Validate request and generate X-Signature for ticket booking
   * @param {Object} ticketDetails - The ticket booking details
   * @returns {Promise} - Promise with signature
   */
  validateRequest(ticketDetails) {
    return requests.post(`/ticketbooking/validate-request`, { ticketDetails });
  },

};

export default TicketBookingService;
